// third-party
// assets
import { IconUserSearch, IconUserEdit } from '@tabler/icons-react';
import { permissions } from '../auth/config';

// constant
const icons = {
  IconUserSearch,
  IconUserEdit
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const accounts = {
  id: 'accounts',
  title: 'Accounts',
  // title: <FormattedMessage id="accounts" />,
  type: 'group',
  permission: permissions.VIEW_ACCOUNTS,
  children: [
    {
      id: 'search-accounts',
      title: 'Search Accounts',
      // title: <FormattedMessage id="Search Accounts" />,
      type: 'item',
      icon: icons.IconUserSearch,
      url: '/accounts',
      breadcrumbs: false,
      permission: permissions.VIEW_ACCOUNTS,
      children: [
        {
          id: 'account-info',
          title: 'Account Info',
          // title: <FormattedMessage id="Device Info" />,
          type: 'item',
          url: '/accounts/account-info',
          icon: icons.IconUserEdit,
          breadcrumbs: true,
          permission: permissions.VIEW_ACCOUNTS
        }
      ]
    }
  ]
};

export default accounts;
